module.exports = __webpack_public_path__ + "static/img/vgjc.7c00123.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/vgjc.png
// module id = gMrX
// module chunks = 1